import styled from '@emotion/styled'
import { stylesIf, themeColor } from 'utils/styles'

const withStyle = (Component) =>
  styled(Component)((props) => {
    const { headerColor, headerColorWhite, headers } = props.theme
    const color = props.color || (props.white ? headerColorWhite : headerColor)
    return `
        font-family: Arial;
        font-size: ${headers[props.type].fontSize};
        line-height: ${headers[props.type].lineHeight};
        margin: ${headers[props.type].margin};
        font-weight: ${props.weight ? props.weight : 'bold'};
        font-style: normal;
        font-stretch: normal;
        letter-spacing: normal;
        color: ${color};
        ${stylesIf(props.link, `color: ${themeColor('blueSecondary', props)};`)}
      `
  })

export default withStyle
